import { createContext, useContext } from 'react';

export type StylePath = string;

export interface StyleEditorContextValue {
  openDrawer: (path: StylePath) => void;
  closeDrawer: () => void;
  openedPath: StylePath | null;
  isOpen: boolean;
  hoveredPath: StylePath | null;
  setHoveredPath: (path: StylePath | null) => void;
}

export const StyleEditorContext = createContext<StyleEditorContextValue | null>(
  null,
);

export const useStyleEditor = () => {
  const ctx = useContext(StyleEditorContext);

  if (!ctx) {
    throw new Error('useStyleEditor must be used within StyleEditorProvider');
  }

  return ctx;
};
